const phoneReplace = (value) => {
    if (!value) return ""
    value = value.replace(/\D/g,'')
    value = value.replace(/(\d{2})(\d)/,"($1) $2")
    value = value.replace(/(\d)(\d{4})$/,"$1-$2")
    return value.substring(0, 15)
};

const htmlToText = (value) => {
    return value.replace(/<[^>]+>/g, '')
}

export { phoneReplace, htmlToText };
